(() => {
  if (customElements.get("featured-products-slideshow")) {
    return;
  }

  class FeaturedProductsSlideshow extends HTMLElement {
    constructor() {
      super();

      this.swiper = new Swiper(this, {
        slidesPerView: 2,
        spaceBetween: 8,
        navigation: {
          nextEl: this.querySelector('[data-next]'),
          prevEl: this.querySelector('[data-prev]')
        },
        breakpoints: {
          768: {
            slidesPerView: 3
          }
        }
      });
    }
  }

  customElements.define("featured-products-slideshow", FeaturedProductsSlideshow);
})();
